var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUdhaaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41667 14.168C5.08515 14.168 4.7672 14.2997 4.53278 14.5341C4.29836 14.7685 4.16667 15.0864 4.16667 15.418C4.16667 15.8782 3.79357 16.2513 3.33333 16.2513C2.8731 16.2513 2.5 15.8782 2.5 15.418C2.5 14.6444 2.80729 13.9026 3.35427 13.3556C3.90125 12.8086 4.64312 12.5013 5.41667 12.5013H15.8333C16.2936 12.5013 16.6667 12.8744 16.6667 13.3346C16.6667 13.7949 16.2936 14.168 15.8333 14.168H5.41667Z",
    fill: "#161B2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41667 3.33464C5.08515 3.33464 4.7672 3.46633 4.53278 3.70075C4.29836 3.93517 4.16667 4.25311 4.16667 4.58464V15.418C4.16667 15.7495 4.29836 16.0674 4.53278 16.3019C4.7672 16.5363 5.08515 16.668 5.41667 16.668H15V3.33464H5.41667ZM3.35427 2.52224C3.90125 1.97526 4.64312 1.66797 5.41667 1.66797H15.8333C16.2936 1.66797 16.6667 2.04106 16.6667 2.5013V17.5013C16.6667 17.9615 16.2936 18.3346 15.8333 18.3346H5.41667C4.64312 18.3346 3.90125 18.0273 3.35427 17.4804C2.80729 16.9334 2.5 16.1915 2.5 15.418V4.58464C2.5 3.81109 2.80729 3.06922 3.35427 2.52224Z",
    fill: "#161B2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdhaaricon);
export default __webpack_public_path__ + "static/media/udhaaricon.3fa64375ba4918be629e3895a9b6e9b9.svg";
export { ForwardRef as ReactComponent };